export const numCellSx = {
	textAlign: "right",
	fontVariantNumeric: "tabular-nums",
};
export const centerSx = { textAlign: "center" };
export const dimSx = { color: "text.disabled" };

export const formatLength = (totalInches: number): string => {
	const abs = Math.abs(Math.round(totalInches));
	return `${Math.floor(abs / 12)}' ${abs % 12}"`;
};
